import React, { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import { Col } from "react-bootstrap";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import useWindowSize from "../../../hooks/useWindowSize";
import { setTitle } from "../../../redux/slices/templateTitleSlice.js";
import { useParams, useSearchParams } from "react-router-dom";
import { designTypes } from "../../../constants/common";
import FilterButtons from "./filterButtons";
import { getTemplateHeadings } from "./templateHeadings";
import renderCarouselItems from "./carouselItems";
import GtagService from "../../../services/GtagService";


const Templates = () => {
  const [divs, setDivs] = useState([]);
  const [activeId, setActiveId] = useState(null);

  const [originalDivs, setOriginalDivs] = useState([]);
  const { isDesktop } = useWindowSize();
  const dispatch = useDispatch();
  const titleFromRedux = useSelector((state) => state.titleSlice.title);

  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.landingPages,
  }));

  const templateHeadings = getTemplateHeadings(lang);
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/entry/constructor/templates");
        const filteredData = response.data
          .filter((item) =>
            item.pagesSortedByPositionMeQr.some((page) => page.image)
          )
          .filter((item) => item.title !== "Wi-Fi");

        const transformedData = filteredData.map((item, index) => ({
          id: index + 1,
          title: item.title,
          pages: item.pagesSortedByPositionMeQr,
        }));

        setDivs(transformedData);
        setOriginalDivs(transformedData);
        setActiveId(transformedData[0]?.id);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (!originalDivs.length) {
      return;
    }
    const urlParamsTitle = new URLSearchParams(window.location.search).get(
      "title"
    );
    if (titleFromRedux || urlParamsTitle) {
      const divToActivate = originalDivs.find(
        (div) => div.title === titleFromRedux || div.title === urlParamsTitle
      );
      if (divToActivate) {
        moveToTop(divToActivate.id);
      }
      dispatch(setTitle(""));
    }
  }, [titleFromRedux, originalDivs, dispatch]);

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    if (hash) {
      const divToActivate = originalDivs.find(
        (div) => div.title.replace(/\s+/g, "") === hash
      );
      if (divToActivate) {
        moveToTop(divToActivate.id);
        window.location.hash = "";
      }
    }
  }, [originalDivs]);

  const moveToTop = (id) => {
    const updatedDivs = originalDivs.filter((div) => div.id !== id);
    const selectedDiv = originalDivs.find((div) => div.id === id);
    if (selectedDiv) {
      setDivs([selectedDiv, ...updatedDivs]);
      setActiveId(id);
    }
  };


  const { id } = useParams();
  const [searchParams] = useSearchParams();
  
  const locale = useSelector((state) => state.changeLang.change);
  const designType = useSelector((state) => state.customizeQr.designType);

  const editId = id;

  const handleRedirectClick = async (pageId) => {
    if (isRedirecting) return;
    setIsRedirecting(true);
    
    const localePrefix = locale !== "en" ? `/${locale}` : "";

    if (designType === designTypes.art) {
      sessionStorage.setItem("artQr", "true");
    }

    const oldId = searchParams.get('oldId');
    const oldIdPathSegment = oldId ? `/${oldId}` : '';

    const url = window.location.href.includes("/edit/template?back=/entry")
      ? `${localePrefix}/entry/constructor/clone/${pageId}/${editId}`
      : `${localePrefix}/entry/constructor/clone/${pageId}${oldIdPathSegment}`;

    await GtagService.gtagEventAndNavigate({
      event: "publish_page_template",
      targetUrl: url,
      timeout: 1000,
      params: { site_language: locale.toUpperCase() },
    });
  };


  return (
    <>
      <FilterButtons originalDivs={originalDivs} action={moveToTop} activeId={activeId} />
      <div className="bg-white rounded py-5">
        <Col xs={11} md={10} className="mx-auto">
          <h1 className="fs-2 mb-4 text-center">{lang[2]}</h1>
          {divs.map((div) => (
            <div key={div.id} className="pb-5 mb-5 border-bottom">
              <div className="pb-lg-5 pb-3">
                <h2 className="fs-3 mb-4">
                  {templateHeadings[div.title] || div.title}
                </h2>
                <Carousel
                  interval={null}
                  indicators={
                    isDesktop ? div.pages.length > 4 : div.pages.length > 2
                  }
                  controls={
                    isDesktop ? div.pages.length > 4 : div.pages.length > 2
                  }
                >
                  {isDesktop
                    ? renderCarouselItems(div.pages, 4, handleRedirectClick)
                    : renderCarouselItems(div.pages, 2, handleRedirectClick)}
                </Carousel>
              </div>
            </div>
          ))}
        </Col>
      </div>
    </>
  );
};

export default Templates;
